"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Gambler = /*#__PURE__*/function () {
  function Gambler(_ref) {
    var index = _ref.index;

    _classCallCheck(this, Gambler);

    _defineProperty(this, "index", null);

    _defineProperty(this, "hand", {});

    _defineProperty(this, "attacker", false);

    this.index = index;
  }

  _createClass(Gambler, [{
    key: "getHand",
    value: function getHand(suit) {
      var _ref2;

      var arr = (_ref2 = []).concat.apply(_ref2, _toConsumableArray(Object.values(this.hand)));

      if (!suit) {
        return arr;
      }

      return arr.filter(function (card) {
        return card.suit === suit;
      }).sort(function (card_1, card_2) {
        return card_1.rank <= card_2.rank;
      });
    }
  }, {
    key: "addToHand",
    value: function addToHand(cards) {
      var _iterator = _createForOfIteratorHelper(cards),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var card = _step.value;

          if (!this.hand[card.rank]) {
            this.hand[card.rank] = [];
          }

          this.hand[card.rank].push(card);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "removeFromHand",
    value: function removeFromHand(card) {
      var cards = this.hand[card.rank].filter(function (c) {
        return c.id !== card.id;
      });
      this.hand[card.rank] = cards;
      return true;
    }
  }, {
    key: "name",
    get: function get() {
      return "Gambler_".concat(this.index);
    }
  }, {
    key: "isAttacker",
    get: function get() {
      return this.attacker;
    }
  }, {
    key: "isRobot",
    get: function get() {
      return this.index === _constants.GAMBLERS.ROBOT;
    }
  }, {
    key: "isHandEmpty",
    get: function get() {
      var _ref3;

      return (_ref3 = []).concat.apply(_ref3, _toConsumableArray(Object.values(this.hand))).length === 0;
    }
  }]);

  return Gambler;
}();

exports["default"] = Gambler;